import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import { TypographyKeys } from '@thanx/uikit/theme/typography'
import { Toggle } from '@thanx/uikit/toggle'
import React from 'react'

import Section from 'components/Section'
import { buildTranslate } from 'locales'
import { useDispatch, useSelector } from 'react-redux'
import CmsPage from 'scenes/Cms/components/CmsPage'
import PublishBanner from 'scenes/Cms/components/PublishBanner'
import { setInstoreScanningEnabled } from 'slices/Cms/Settings/ScannableCodes'
import {
  selectFormDisabled,
  selectInstoreScanningEnabled,
  selectIsFormSubmitting,
} from 'slices/Cms/Settings/ScannableCodes/selectors'
import { merchantTheme } from 'theme'
import { useScannableCodesFormInitialize } from './hooks/useScannableCodesFormInitialize'
import { useScannableCodesSubmitForm } from './hooks/useScannableCodesSubmitForm'
import Sidebar from './Sidebar'

const t = buildTranslate('cms.settings.scannable_codes')

const ScannableCodes: React.FC<{ showTitle?: boolean }> = ({
  showTitle = true,
}) => {
  const dispatch = useDispatch()
  const [css] = useStyletron()

  useScannableCodesFormInitialize()

  const instoreScanningEnabled = useSelector(selectInstoreScanningEnabled)
  const isSubmitting = useSelector(selectIsFormSubmitting)
  const formDisabled = useSelector(selectFormDisabled)

  const handleSubmit = useScannableCodesSubmitForm()
  const handleToggleChange = (checked: boolean) => {
    dispatch(setInstoreScanningEnabled(checked))
  }

  const greyTextCss = css({ color: merchantTheme.colors.grey50 })

  return (
    <CmsPage
      showTitle={showTitle}
      title={t('title')}
      description={t('description')}
      sidebar={
        <Sidebar
          isSubmitting={isSubmitting}
          formDisabled={formDisabled}
          handleSubmit={handleSubmit}
        />
      }
    >
      <Section className="p-m mb-m">
        <Text className="mb-s d-block" typography={TypographyKeys.Header4}>
          {t('qr_codes.title')}
        </Text>
        <div className="d-flex align-items-start">
          <Toggle
            checked={instoreScanningEnabled}
            onChange={handleToggleChange}
            className="me-3"
            disabled={formDisabled}
          />
          <div className="d-flex flex-column">
            <Text
              className={`mb-xs ${formDisabled ? greyTextCss : ''}`}
              typography={TypographyKeys.BodyText3}
            >
              {t('qr_codes.label')}
            </Text>
            <Text
              className={`mb-xs ${greyTextCss}`}
              typography={TypographyKeys.BodyText4}
            >
              {t('qr_codes.description')}{' '}
              <a
                href={t('qr_codes.learn_more_url')}
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none"
              >
                {t('qr_codes.learn_more')}
              </a>
            </Text>
          </div>
        </div>
      </Section>

      <PublishBanner
        buttonText={t('publish')}
        isLoading={isSubmitting}
        disabled={formDisabled}
        onClick={handleSubmit}
      />
    </CmsPage>
  )
}

export default ScannableCodes
